import React from 'react';
import { Link } from 'react-router-dom';
import { AgentProfile, Button, Space } from 'components';

import type { Offer801VerificationTask } from '@/app-package';
import ListingSection from './ListingSection';
import TaskLayout from './TaskLayout';

type OfferFormSubmittedItemProps = {
  itemData: Offer801VerificationTask['data'];
};

const OfferFormSubmittedItem: React.FC<OfferFormSubmittedItemProps> = ({
  itemData,
}) => (
    <TaskLayout
      title="Offer Doc Submitted"
      content={
        <Space direction="vertical">
          <ListingSection
            dataCy="offer-doc-listing-data"
            listing={{
              line1: itemData.line1,
              line2: itemData.line2,
              thumbnail: itemData.thumbnail,
            }}
          />
          <AgentProfile user={itemData.coop} showOrgName nameTextStrong />
        </Space>
      }
      buttons={
        <Link
          to={`/listing/${itemData.listingId}/offer/?showForm801Modal=true&offerId=${itemData.offerId}`}
          data-cy="offer-doc-review"
        >
          <Button size="small">Review Offer Doc</Button>
        </Link>
      }
      dataCy="offer-doc-task-item"
    />
  );

export default OfferFormSubmittedItem;
